import { createContext, useContext, useEffect } from 'react';
import { seoContent } from './content/seo';

const LANG = 'es';

const LanguageContext = createContext({ lang: LANG, withPath: (path) => path });

export function LanguageProvider({ children }) {
    const withPath = (path) => path;

    useEffect(() => {
        document.documentElement.lang = LANG;
        const seo = seoContent[LANG];
        document.title = seo.title;
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) metaDescription.setAttribute('content', seo.description);
    }, []);

    return (
        <LanguageContext.Provider value={{ lang: LANG, withPath }}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useLanguage() {
    return useContext(LanguageContext);
}
